import { HvlDateConverter, HvlMapConverter } from '@hvlng/framework-bff/util';
import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl, HvlBaseModel, Required } from '@hvlng/framework-bff/core';

import { PerObjectModel } from '../../../../model/per-object-model';
import { TextModel, CodeTextDiscriminatorModel } from 'humanresources-common-shared';

@JsonObject('KovanHrPositionModel')
export class PositionModel extends HvlBaseModel {
    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;

    @EmptyControl()
    @JsonProperty('objectNumber', String, true)
    objectNumber: string = null;

    @EmptyControl()
    @JsonProperty('count', Number, true)
    count: number = null;

    @EmptyControl()
    @JsonProperty('perObjectId', Number, true)
    perObjectId: number = null;

    @Required()
    @JsonProperty('objectCode', String, true)
    objectCode: string = null;

    @Required()
    @JsonProperty('position', String, true)
    position: string = null;

    @EmptyControl()
    @JsonProperty('managerialPosition', Boolean, true)
    managerialPosition: boolean = false;

    @EmptyControl()
    @JsonProperty('singleIncubentPosition', Boolean, true)
    singleIncubentPosition: boolean = false;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionText', String, true)
    perObjectDefinitionText: string = null;

    @Required()
    @JsonProperty('shortText', String, true)
    shortText: string = null;

    @EmptyControl()
    @JsonProperty('longText', String, true)
    longText: string = null;

    @JsonProperty('perObject', PerObjectModel, true)
    perObject: PerObjectModel = new PerObjectModel();

    @JsonProperty('detailMap', HvlMapConverter, true)
    detailMap: Map<string, TextModel> = new Map<string, TextModel>();

    @EmptyControl()
    @JsonProperty('perEmployeeTypeUuid', String, true)
    perEmployeeTypeUuid: string = null;

    @EmptyControl()
    @JsonProperty('perEmployeeSubTypeUuid', String, true)
    perEmployeeSubTypeUuid: string = null;

    @EmptyControl()
    @JsonProperty('perStaffClass', String, true)
    perStaffClass: string = null;

    @EmptyControl()
    @JsonProperty('capacityWithStaticInfo', String, true)
    capacityWithStaticInfo: string = null;

    @Required()
    @JsonProperty('objectStatusId', Number, true)
    objectStatusId: number = null;

    @EmptyControl()
    @JsonProperty('objectStatus', CodeTextDiscriminatorModel, true)
    objectStatus: CodeTextDiscriminatorModel = null;

    @JsonProperty('countCapacity', String, true)
    countCapacity: string = null;

    @JsonProperty('capacityPosition', String, true)
    capacityPosition: string = null;

    @EmptyControl()
    @JsonProperty('objectStatusText', String, true)
    objectStatusText: string = null;

    @EmptyControl()
    @JsonProperty('active', Boolean, true)
    active: boolean = null;

    @Required()
    @JsonProperty('capacity', Number, true)
    capacity: number = null;

    @EmptyControl()
    @JsonProperty('degreeOfCadree', Number, true)
    degreeOfCadree: number = null;

    @EmptyControl()
    @JsonProperty('authorizationLevelId', Number, true)
    authorizationLevelId: number = null;
}
